import SecureCallback from '@/pages/SecureCallback';

import PaymentProject from '@/pages/PaymentProject';
import BillAmount from '@/pages/BillAmount';
import BillContentSecure from '@/pages/BillContentSecure';

import EnterCard from '@/pages/EnterCard';
import ThreeDSecure from '@/pages/ThreeDSecure';
import PendingPayment from 'views/PendingPayment';
import PaymentOrigin from 'views/PaymentOrigin';
import CryptoProcessing from 'views/CryptoProcessing';

import HistoryTransactionList from 'views/HistoryTransactionList';

import PaidPayment from 'views/PaidPayment';
import PaidDigitalSelling from '@/pages/PaidDigitalSelling';

import Subscription from '@/pages/subscription/layouts/Subscription';
import SubscriptionSecure from '@/pages/subscription/layouts/SubscriptionSecure';

import PersonalPaymentScreen from 'views/PersonalPayment';
import FailedPayment from 'views/FailedPayment';
import RejectedPayment from 'views/RejectedPayment';
import ExpiredPayment from 'views/ExpiredPayment';
import ServiceError from 'views/ServiceError';
import ProjectBlocked from 'views/ProjectBlocked';
import BillBlocked from 'views/BillBlocked';
import BillPayed from 'views/BillPayed';

import SafeDeal from 'views/SafeDeal';
import SmsConfirmationCode from 'views/SmsConfirmationCode';
import CvcConfirmationCode from 'views/CvcConfirmationCode';
import NoTicketsLeft from 'views/NoTicketsLeft';
import ContentReturned from 'views/ContentReturned';

import isPaymentPaid from './middleware/isPaymentPaid';
import paymentAccessPermission from './middleware/paymentAccessPermission';

const MAIN_ROUTES = [
  {
    path: '/success',
    name: 'success',
    component: SecureCallback,
    meta: { title: 'secure callback success' },
  },
  {
    path: '/fail',
    name: 'fail',
    component: SecureCallback,
    meta: { title: 'secure callback fail' },
  },
  {
    path: '/wait',
    name: 'wait',
    component: SecureCallback,
    meta: { title: 'secure callback wait' },
  },
  {
    path: '/blocked',
    name: 'bill.blocked',
    component: BillBlocked,
    meta: { title: 'bill blocked' },
  },
  {
    path: '/denied',
    name: 'project.blocked',
    component: ProjectBlocked,
    meta: { title: 'project blocked' },
  },
  {
    path: '/payed',
    name: 'bill.payed',
    component: BillPayed,
    meta: { title: 'bill payed' },
  },
  {
    path: '/404',
    name: 'service.error',
    component: ServiceError,
    meta: { title: 'service error' },
  },
  {
    path: '/entercard',
    name: 'EnterCard',
    component: EnterCard,
    meta: { title: 'enter card' },
  },
  {
    path: '/crypto',
    name: 'crypto.processing',
    component: CryptoProcessing,
    meta: { title: 'crypto processing' },
  },
  {
    path: '/history/:id',
    name: 'history.transaction.list',
    component: HistoryTransactionList,
    meta: { title: 'history transaction list' },
  },
  {
    path: '/confirmation/sms',
    name: 'confirmation.sms',
    component: SmsConfirmationCode,
    meta: { title: 'sms confirmation code' },
  },
  {
    path: '/confirmation/cvc',
    name: 'confirmation.cvc',
    component: CvcConfirmationCode,
    meta: { title: 'cvc confirmation code' },
  },
  {
    path: '/secure',
    name: 'ThreeDSecure',
    component: ThreeDSecure,
    props: true,
    meta: { title: 'secure payment' },
  },
  {
    path: '/pending',
    name: 'pending.payment',
    component: PendingPayment,
    meta: { title: 'pending payment' },
  },
  {
    path: '/origin',
    name: 'payment.origin',
    component: PaymentOrigin,
    meta: { title: 'payment origin' },
  },
  {
    path: '/expired',
    name: 'expired.payment',
    component: ExpiredPayment,
    meta: { title: 'expired payment' },
  },
  {
    path: '/paid',
    name: 'paid.payment',
    component: PaidPayment,
    meta: {
      title: 'paid payment',
      middleware: [
        isPaymentPaid,
      ],
    },
  },
  {
    path: '/receipt',
    name: 'receipt.payment',
    meta: {
      title: 'receipt payment',
      middleware: [
        paymentAccessPermission,
      ],
    },
  },
  {
    path: '/failed',
    name: 'failed.payment',
    component: FailedPayment,
    meta: { title: 'failed payment' },
  },
  {
    path: '/rejected',
    name: 'rejected.payment',
    component: RejectedPayment,
    meta: { title: 'rejected payment' },
  },
  {
    path: '/no-tickets-left',
    name: 'no.tickets.left',
    component: NoTicketsLeft,
    meta: { title: 'no tickets left' },
  },
  {
    path: '/content/returned',
    name: 'content.returned',
    component: ContentReturned,
    meta: { title: 'content returned' },
  },
  {
    path: '/deal/:step',
    name: 'safe.deal',
    component: SafeDeal,
    meta: { title: 'safe deal' },
  },
  {
    path: '/:id',
    name: 'PaymentProject',
    component: PaymentProject,
    meta: { title: 'payment to project' },
  },
  {
    path: '/bill/:id',
    name: 'BillAmount',
    component: BillAmount,
    meta: { title: 'bill payment' },
  },
  {
    path: '/content/paid',
    name: 'PaidDigitalSelling',
    component: PaidDigitalSelling,
    meta: { title: 'bill digital selling' },
  },
  {
    path: '/content/:id',
    name: 'BillContentSecure',
    component: BillContentSecure,
    meta: { title: 'bill secure' },
  },
  {
    path: '/dev/:projectCode',
    name: 'personal.payment',
    component: PersonalPaymentScreen,
    meta: { title: 'payment to project' },
  },
  {
    path: '*',
    redirect: { name: 'service.error' },
  },
];

const SUBSCRIPTION_ROUTES = [
  {
    path: '/subscription/manage',
    name: 'Subscription',
    component: Subscription,
    meta: { title: 'subscription manage' },
  },
  {
    path: '/subscription/:id',
    name: 'SubscriptionSecure',
    component: SubscriptionSecure,
    meta: { title: 'subscription secure' },
  },
].filter(i => i);

export default [
  ...MAIN_ROUTES,
  ...SUBSCRIPTION_ROUTES,
];
